/**
 * 高风险订单
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import { Spin, Space, Tooltip,message} from "antd";
import {symbolMoneyUtil} from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
import {Link} from "react-router-dom";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import HttpServerAction from '@/api/httpServer.action';
import dayjs from 'dayjs';
import ModalOrderDetail from "@components/ModalOrderDetails/ModalOrderDetail";
import EssaModal from '@components/EssaModal/EssaModal';
import "./list.less";

class List extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            //
            tabKay: '1',//	列表页签 1:待提货 2:需送车 3:已提货
            // 搜索默认 10:客户编码 20:联系人名称 30:联系人电话
            sKeywordType: "10",
            // 搜索配置
            searchFormOptionsOne:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'times',
                    // cnTitle:'注册时间',
                    // cnTitleId:'ZhuCeShiJian',
                    type:'DateRangePicker',
                    // cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    // cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['createTimeStart','createTimeEnd'],
                },
                {
                    name:'poCode',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'订单编号',
                    cnPlaceholderId:'DingDanBianHao',
                    width:216,
                },
                {
                    name:'buyerCode',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索客户编号或名称',
                    cnPlaceholderId:'SouSuoKeHuBianHaoHuoMinCheng',
                    width:216,
                },
            ],
            columns:[
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    width: 150,
                    dataIndex: 'buyerCode', // buyerCode
                    render:(buyerCode, record={}, index) => (<div>
                        {record.buyerId?<Link className="color-blue"
                                             target={"_blank"}
                                             to={`/customer/detail?id=${record.buyerId}`}>{buyerCode}</Link>:buyerCode}
                        {record.submitChinaOrder==1?<div className={"black66 font_12"}>
                            {Lang({id:"KeHuYaoQiuZhiFa",default:"客户要求直发"})}
                        </div>:null}
                    </div>),
                },
                {
                    cnTitle: 'PO订单',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODingDan',
                    width:200,
                    render:(poCode, record, index) => (<>
                        <p>
                            <ModalOrderDetail id={record.poId}>
                                <span className={"fw_700 black89 cursor-p"}>{poCode}</span>
                            </ModalOrderDetail>
                        </p>
                        <p>
                            {Lang({id:"NKuanNXiang",default:"{0} 款，{1} 箱",params:[record.itemCount,record.totalQuantity]})}
                        </p>
                        <p className={"black45"}>
                            <Tooltip placement="right" title={Lang({id:"ChuangJianShiJian", default:"创建时间"})}>
                                <span className={"ri-time-line"} />
                                <span className={"font_12 ml_4"}>{record.createTime? dayjs(record.createTime).format("YYYY-MM-DD"): "-"}</span>
                            </Tooltip>
                        </p>

                    </>)
                },
                {
                    cnTitle: '订单金额',
                    cnTitleId: 'DingDanJinE',
                    dataIndex: 'totalPrice',
                    render:(text, record, index) => (
                        <p className={"fw_700"}>
                            {symbolMoneyUtil(record.totalPrice, record.currencySymbol)}
                        </p>
                    ),
                    width:150,
                },
                {
                    cnTitle: '订单状态',
                    cnTitleId: 'DingDanZhuangTai',
                    dataIndex: 'orderStatus',
                    width: 200,
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                },
                {
                    cnTitle: '客户还要³',
                    cnTitleId: 'KeHuHaiYao',
                    dataIndex: 'hasNeed',
                    width:200,
                    render:(hasNeed, record, index) => (
                        <div className={"color-err fw_700"}>
                            {/* hasNeed  1:还要*/}
                            {hasNeed==1?<span>{Lang({id:"KeHuHaiYao",default:"客户还要"})}</span>:null}
                        </div>
                    )
                },
                {
                    cnTitle: '入库天数',
                    cnTitleId: 'RuKuTianShu',
                    dataIndex: 'inStorageDay',
                    width: 150,
                    render:(inStorageDay, record, index) => (
                        <span className={"color-err"}>
                          {inStorageDay?Lang({id:"YiRuKuTian",default:`已入库 ${inStorageDay} 天`,params:[inStorageDay]}):""}
                        </span>
                    ),
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 120,
                    fixed:'right',
                    // align:"right",
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<>
                        <AuthBtn icon={"ri-file-close-line"}
                                 onClick={()=>this.openAbandonModal(true,record,1)}
                                 tips = {Lang({id:"KeHuBuXiangYaoLe",default:"客户不想要了"})}/>
                        <span className={"ml_8"}>
                            <AuthBtn icon={"ri-check-double-line"}
                                     onClick={()=>this.openAbandonModal(true,record,0)}
                                     tips = {Lang({id:"KeHuHaiYao",default:"客户还要"})}/>
                        </span>
                    </>)},
            ],
            total: 0,
        }
    }
    //放弃货物
    openAbandonModal(flag,record={},isSurrenderGoods){
         this.setState({
             showAbandonModal:flag,
             currRow:record,
             isSurrenderGoods:isSurrenderGoods
         })
    }
    /*
    * PO单放弃货权
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8537
    * */
    abandonTheGoods(isSurrenderGoods){
        const {currRow} = this.state;
        this.loading(true);
        HttpServerAction.postHttpAction('/service/mg/sale/po/surrender-goods',{
            poId: currRow.poId,
            isSurrenderGoods:isSurrenderGoods,//0:客户还要 1:客户不想要了
        },).then((resp)=>this.handleGetRes(resp.data)).catch(err=>this.handleGetRes(err));
    }
    handleGetRes(res={}) {
        const {success, valid,} = res;
        this.loading(false);
        if (success && valid) {
            this.openAbandonModal(false)
            this.onRefTabChildOne.handleFetch(1,{},true)
        }else{
            // 请先新增合同
            message.open({
                type: 'warning',
                content: res.message||Lang({id: 'CaoZuoShiBai',default:'操作失败'})
            });
        }
    }
    loading(flag=false){
        this.setState({
            loading: flag
        })
    }
    /**
     * 改变状态
     **/
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;

    /**
     * 重置
     * */
    searchReset(){
        this.setState({
            sKeyword:"",
            sKeywordType: "10",
        },()=>this.onRefTabChildOne.handleFetch(1,{},false))
    }
    // 查询回调
    changeNum(waitConfirmNum=0,waitPayNum=0){
        this.setState({
            waitConfirmNum: waitConfirmNum,
            waitPayNum: waitPayNum,
        } )
    };
    fetchCallBack(res={}){
        const { model ={}, paging={}} = res;
        this.changeNum(model.waitConfirmNum,model.waitPayNum)
        this.setState({
            currPage:paging.pageNum || 1
        })
        this.onRefPageCommonChild.isShowTop();
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    componentDidMount() {}
    componentWillMount() {

    }
    render(){
        const { loading,searchFormOptionsOne,columns, showAbandonModal=false,isSurrenderGoods=null} = this.state;
        const currPageName = Lang({id: "GaoFengXianDingDan",default: "高风险订单"});
        return (
            <PageCommon onRef={this.onRefPageCommon}>
                <Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className="highRiskOrderWrap">
                    <AutoFetchTable columns={columns}
                                    rowKey={'poId'}
                                    onRef={this.onRefTabOne}
                                    fetchCallBack={(data)=>this.fetchCallBack(data)}
                                    scroll={{x:1300,}}
                                    searchFormOptions={searchFormOptionsOne}
                                    precondition={{
                                        ishHghRiskOrder: 1,//是否高风险订单,0:否 1:是
                                    }}
                                    fetchApi={'/service/mg/statistics/sale-data'}>
                    </AutoFetchTable>
                </div>
                    <EssaModal title={isSurrenderGoods==1?Lang({id: "KeHuFangQiHuoWu",default: "客户放弃货物"}):Lang({id:"KeHuHaiYao",
                        default:"客户还要"
                    })}
                                open={showAbandonModal}
                                width={500}
                                onOk={()=>this.abandonTheGoods(isSurrenderGoods)}
                                onCancel={()=>this.openAbandonModal(false)}>
                        <div className={"color-err mb_16"}>
                            {isSurrenderGoods==1?Lang({id:"KeHuFangQiHuoWuCiCaoZuoJi",
                                default:"客户放弃货物，此操作将不退款，并把货物转为库存商品。请确认是否已放弃货物？"
                            }):""}
                        </div>
                    </EssaModal>
            </Spin>
        </PageCommon>)
    }
}

export default List;
